import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralVisibilityBoostVisibilityBoostModal from 'lumen/components/general/visibility-boost/visibility-boost-modal';
import type { Day } from 'lumen/models';
import type AccessService from 'lumen/services/access';

interface GeneralVisibilityBoostVisibilityBoostButtonSignature {
  Args: {
    day: Day;
    isInactiveDay: boolean;
  };
}

export default class GeneralVisibilityBoostVisibilityBoostButton extends Component<GeneralVisibilityBoostVisibilityBoostButtonSignature> {
  @service declare access: AccessService;

  @tracked
  isVisibilityBoostModalOpen = false;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get displayButton() {
    return (
      this.access.hasVisibilityBoostViewAccess &&
      !this.args.isInactiveDay &&
      this.args.day?.marketingRecommendations?.length > 0
    );
  }

  @action closeVisibilityBoostModal(): void {
    this.isVisibilityBoostModalOpen = false;
  }

  @action openVisibilityBoostModal(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    this.isVisibilityBoostModalOpen = true;
  }

  <template>
    {{#if this.displayButton}}
      <PrismButton
        @buttonType="intelligence-secondary"
        @iconBefore="megaphone"
        @label={{t "visibility_boost.calendar.button"}}
        @onClick={{this.openVisibilityBoostModal}}
        @size="small"
        {{! VISIBILITY BOOST PHASE 1: part of temporary solution to truncate the boost visibility button so it fits within the layout on smaller screens }}
        class="truncate"
      />
      <PrismTooltip @text={{t "visibility_boost.calendar.button_tooltip"}} />
      {{#if this.isVisibilityBoostModalOpen}}
        <GeneralVisibilityBoostVisibilityBoostModal
          @day={{@day}}
          @onClose={{this.closeVisibilityBoostModal}}
        />
      {{/if}}
    {{/if}}
  </template>
}
